var map = {
	"./envelope03en.png": "bFWf",
	"./envelope03khm.png": "x2KH",
	"./envelope03thai.png": "ykMR",
	"./envelope03vi.png": "2Fjr",
	"./envelope03zh-tw.png": "POIX"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Lt6F";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img ^\.\/envelope03.*\.png$
// module id = Lt6F
// module chunks = 1